<template>
  <Modal class="mask long-modal top-modal"  width="800" style="max-height:80%; over-flow:auto"  v-model="show" :mask-closable="false" >
    <div slot="header" class="modal-header">
      账单明细
      <div class="fr mr60 error-color">
        <span>{{`房间/床位数：${roomsCount}`}}</span>
        <span>{{`账单总额：${totalMoney}`}}</span>
      </div>
    </div>
 
    <div class=" pt16 pb16">
      <table-list :showPage ="false" :columns="columns" :data="tableData" :loading="tableLoading"></table-list>
    </div>
    <div slot="footer">
      <div v-if="isRead">  
        <Button  type="primary" size="large" @click="close">返回</Button>
      </div>
      <div v-else>
        <Button type="text" size="large" @click="close">返回</Button>
        <Button type="primary" size="large" @click="createContract" :loading="loading">
          <span>确认并创建</span>
        </Button>
      </div>
    </div>
  </Modal>
</template>
 
<script type="text/ecmascript-6">
 import TableList from "components/TableList/index";
    
export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    closeKey:{
      type:Number,
      default:0
    },
    tableData:{
      type:Array,
      default: []
    },
    isRead: {
      type: Boolean,
      default:true
    },
    roomsCount: {
      type:Number,
      default:0
    },
    totalMoney: {
      type:Number,
      default:0
    }
  },
  watch:{
    n() {
      this.loading = false
      this.show = true
    },
    closeKey(){
      this.loading = false
      this.show = false
    }
  },
  components:{
    TableList
  },
 data () {
  return {
    show:false,
    tableLoading:false,
    loading:false,
    columns:[
      {
      title: "房间号",
      key: "houseNumber",
      align: "center"
     
      },
      {
        title: "标准月租金",
        key: "originRentPrice",
        align: "center"
      
      },
      {
        title: "实际月租金",
        key: "rentPrice",
        align: "center"
      },
      {
        title: "标准服务费",
        key: "originServicePrice",
        align: "center"
      },
      {
        title: "实际服务费",
        key: "servicePrice",
        align: "center"
      },
      {
        title: "标准押金",
        key: "originDepositPrice",
        align: "center"
      },
      {
        title: "实际押金",
        key: "depositPrice",
        align: "center"
      }
    ],
   
 };
 },
 methods:{
   close() {
     this.show = false
   },
   createContract() {
     this.$emit('createContract')
     this.loading = true
   }
 }
}
</script>




